import { cn } from '@/lib/utils'
import { LOCK_REASON_TEXT } from './lockReasonText'
import type { BlockLockReason } from './useBlocksInRun'
import { useUiLang } from '@/i18n'

interface Props {
  /**
   * У правки известен ТОЧНО этот блок — «переписывается» верно. У перевода
   * список блоков неизвестен (§7.5, `useBlocksInRun` отдаёт `kind: 'all'`) —
   * «этот блок переписывается» соврало бы про причину: заперт он не потому,
   * что прогон уже пишет именно в него, а потому что прогон МОЖЕТ дойти до
   * любого блока курса. У проверки прогона нет вовсе — курс ждёт решения.
   */
  reason: BlockLockReason
}

/**
 * Плашка вместо `BlockEditor`, пока выбранный блок заперт (`useBlocksInRun`):
 * прогоном, пишущим в блоки, или проверкой курса. Кнопок нет: остановить
 * прогон нечем, а отзыв заявки живёт в окне публикации. Манера — как у
 * `CourseBusyNotice` (`/10` фон, `/30` бордер, иконка + текст).
 */
export const BlockRunNotice = ({ reason }: Props) => {
  useUiLang()
  const { notice, icon: Icon, spin } = LOCK_REASON_TEXT[reason]
  return (
    <div
      data-testid="block-run-notice"
      role="status"
      className="flex items-start gap-2.5 rounded-2xl border border-warning/30 bg-warning/10 p-4 text-sm text-warning"
    >
      <Icon className={cn('mt-0.5 h-5 w-5 shrink-0', spin ? 'animate-spin' : null)} />
      <p className="font-medium">{notice}</p>
    </div>
  )
}
